var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dragTreeTableDiv"},[_c('dragTreeTable',{attrs:{"data":_vm.treeData,"border":"","fixed":true,"height":_vm.tableHeight,"isdraggable":_vm.isdraggable,"onDrag":_vm.onTreeDataChange}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9edee54c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TreeTableDrag/TreeTableDrag.vue
// module id = 1462
// module chunks = 137